import React from 'react';
import { Calendar, Waves, Bike, Footprints, Apple, LineChart, Droplet, Beef, AlertTriangle } from 'lucide-react';
import { motion } from 'framer-motion';
const items = [{
  icon: <Calendar size={28} data-id="element-45" />,
  title: 'Plan Semanal',
  desc: 'Estructura clara de lunes a domingo. Sabrás exactamente qué hacer cada día sin adivinar.'
}, {
  icon: <Waves size={28} data-id="element-46" />,
  title: 'Rutinas de Natación',
  desc: 'Sesiones enfocadas en técnica y resistencia para dominar el agua con confianza.'
}, {
  icon: <Bike size={28} data-id="element-47" />,
  title: 'Plan de Ciclismo',
  desc: 'Entrenamientos de calidad sobre la bici para ganar potencia en menos tiempo.'
}, {
  icon: <Footprints size={28} data-id="element-48" />,
  title: 'Plan de Running',
  desc: 'Transiciones y series diseñadas para correr fuerte después de pedalear.'
}, {
  icon: <Apple size={28} data-id="element-49" />,
  title: 'Nutrición Deportiva',
  desc: 'Guía básica de alimentación e hidratación para rendir al máximo en tus sesiones.'
}, {
  icon: <LineChart size={28} data-id="element-50" />,
  title: 'Seguimiento de Progreso',
  desc: 'Plantillas para registrar tus tiempos y ver tu evolución semana a semana.'
}];
const highlights = [{
  icon: <Droplet size={24} data-id="element-51" />,
  title: 'Calculadora de Hidratación Diaria',
  desc: 'Sabé exactamente cuánta agua y electrolitos necesitas según tu peso, clima y volumen de entrenamiento.'
}, {
  icon: <Beef size={24} data-id="element-52" />,
  title: 'Calculadora de Proteínas',
  desc: 'Ajustá tu ingesta proteica para optimizar la recuperación muscular sin pasarte ni quedarte corto.'
}, {
  icon: <AlertTriangle size={24} data-id="element-53" />,
  title: 'Suplementos a Evitar y Validados',
  desc: 'Lista clara y honesta de qué suplementos sí funcionan y cuáles son una pérdida de plata.'
}];
export function Includes() {
  return <section className="py-24 bg-black" data-id="element-54">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-55">
        <div className="text-center mb-16" data-id="element-56">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-57">
            ¿Qué incluye el sistema?
          </h2>
          <p className="text-lg text-white/70 max-w-2xl mx-auto" data-id="element-58">
            Todo lo que necesitas para cruzar la meta, organizado en un solo
            lugar.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-20" data-id="element-59">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.08
        }} className="bg-white/5 rounded-2xl p-7 border border-white/10 hover:border-brand-green/40 transition-colors" data-id="element-60">
              <div className="w-12 h-12 rounded-xl bg-brand-green/15 text-brand-green flex items-center justify-center mb-5" data-id="element-61">
                {item.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-62">
                {item.title}
              </h3>
              <p className="text-white/70 leading-relaxed" data-id="element-63">{item.desc}</p>
            </motion.div>)}
        </div>

        <div className="text-center mb-12" data-id="element-64">
          <span className="inline-block px-3 py-1 bg-brand-green/15 text-brand-green text-xs font-bold tracking-wider uppercase rounded-full mb-4" data-id="element-65">
            Contenido destacado del ebook
          </span>
          <h3 className="font-serif text-3xl md:text-4xl font-bold text-white mb-3" data-id="element-66">
            Herramientas exclusivas dentro del libro
          </h3>
          <p className="text-white/70 max-w-2xl mx-auto" data-id="element-67">
            No es solo teoría. Vas a tener calculadoras prácticas y guías
            validadas para aplicar desde el día uno.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-68">
          {highlights.map((h, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-brand-green text-brand-dark rounded-2xl p-7" data-id="element-69">
              <div className="w-12 h-12 rounded-xl bg-brand-dark/10 text-brand-dark flex items-center justify-center mb-5" data-id="element-70">
                {h.icon}
              </div>
              <h4 className="text-lg font-bold mb-3" data-id="element-71">{h.title}</h4>
              <p className="text-brand-dark/80 leading-relaxed text-sm" data-id="element-72">
                {h.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}